import { routeMetaData } from "@/constant/routeMetaConstant";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { matchPath } from "react-router-dom";

export interface RouteMeta {
  pathname: string;
  title?: string;
  logo?: boolean;
  back?: boolean;
  notification?: boolean;
  register?: boolean;
  signin?: boolean;
  search?: boolean;
  home?: boolean;
  bottomNavigation?: boolean;
}

export const defaultRouteMeta: RouteMeta = {
  pathname: "",
  title: "",
  logo: true,
  back: false,
  notification: false,
  register: false,
  signin: false,
  bottomNavigation: false,
};

export const useRouteMeta = () => {
  const location = useLocation();
  const [routeMeta, setRouteMeta] = useState<RouteMeta | null>(null);

  useEffect(() => {
    if (location.pathname.includes("/chicruiting")) {
      const handleMessage = (event: MessageEvent) => {
        if (event.data.key === "routeMetaData") {
          setRouteMeta(event.data.value);
        }
      };

      window.addEventListener("message", handleMessage);

      return () => {
        window.removeEventListener("message", handleMessage);
      };
    } else {
      setRouteMeta(
        routeMetaData.find((routeMeta) => {
          return matchPath(routeMeta.pathname, location.pathname);
        }) || null,
      );
    }
  }, [location.pathname]);

  return routeMeta;
};
